"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addValidator = exports.enValidateMessages = exports.validNumber = exports.validInteger = exports.message = void 0;
function message(constraint, value, validateMessages) {
    if (!constraint)
        return;
    const { required, integer, number, nonNegative, ...otherConstraints } = constraint;
    if (value == null)
        value = "";
    if (required) {
        if (value == "")
            return validateMessages.required;
    }
    if (value == "")
        return; // by default field is not required
    if (integer && !validInteger(value))
        return validateMessages.integer;
    if (number && !validNumber(value))
        return validateMessages.number;
    if (nonNegative && +value < 0)
        return validateMessages.nonNegative;
    for (const key of Object.keys(otherConstraints)) {
        if (customValidators[key]) {
            const constraint = otherConstraints[key];
            const message = customValidators[key](value, constraint);
            if (message)
                return message;
        }
    }
}
exports.message = message;
function validInteger(s) {
    return /^[0-9]*$/.test(s);
}
exports.validInteger = validInteger;
function validNumber(s) {
    return !isNaN(+s);
}
exports.validNumber = validNumber;
exports.enValidateMessages = {
    required: "Field required",
    integer: "Integers only",
    number: "Numbers only",
    nonNegative: "Numbers only",
};
/**
 * Register new custom validator.
 * Registered validators could be used by referencing propertyKeys
 * Be careful not to use propertyKeys that could mess with other propeties, ie `children`.
 *
 * @param propertyKey property name to request vaidation, ie `amount`: `<Input required amount field={form.amount}/>`
 * @param validator function that will run validation
 */
function addValidator(propertyKey, validator) {
    customValidators[propertyKey] = validator;
}
exports.addValidator = addValidator;
const customValidators = {};
